import React from 'react';
import './uploadSuccess.scss';
import { lang } from '@umu/ukit-lang';
import { Button } from '@umu/umu-design';
import { replaceNumText } from 'businessCommon/src/components/@batchImport/util';

export interface IUploadSuccessProps {
    totalNumber: number;
    failedNumber?: number;
    callback?: VoidFunction;
    uploadFile: VoidFunction;
    customSuccessMsg?: (totalNumber: number, failedNumber?: number) => JSX.Element;
}
function UploadSuccess(props: IUploadSuccessProps) {
    const { totalNumber, failedNumber, uploadFile, callback, customSuccessMsg } = props;

    const renderSuccessMsg = () => {
        if (customSuccessMsg) {
            return customSuccessMsg(totalNumber, failedNumber);
        }
        const text = lang('成功导入{$0{0=条,1=条}}数据。', `${totalNumber}`);
        return replaceNumText(text, 'upload-success-num-msg');
    };

    return (
        <div className="success-desc">
            <div className="msg-show">
                <div className="icon-success" />
                <div className="msg-desc">{lang('导入成功')}</div>
            </div>
            <div className="msg-desc-num" dangerouslySetInnerHTML={{ __html: renderSuccessMsg() as string }}></div>
            <div className="btn-rows">
                <Button type="ghost-blue" className="toolbar-input-col" onClick={uploadFile}>
                    {lang('再次上传')}
                </Button>
                <Button type="primary-blue" onClick={callback}>
                    {lang('完成')}
                </Button>
            </div>
        </div>
    );
}

export default UploadSuccess;
